import React from 'react';
import Template from '../../../template';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useAuth } from '../../../context/auth';
import { clearApplicationCache } from '../../../utils/cacheUtils';

function Obrigado() {
  const { setUser } = useAuth();

  const handleLogout = () => {
    console.log('🚪 Iniciando processo de logout da página de obrigado...');
    
    // Limpar token e dados do usuário
    localStorage.removeItem("token");
    setUser({});
    
    // Limpar cache automaticamente no logout usando função utilitária
    clearApplicationCache('logout-manual');
    
    console.log('✅ Logout manual concluído');
    
    // Redirecionar para a página de login
    window.location.href = "/login";
  };

  return (
    <Template>
      <div style={{ 
        background: '#F5F5F5',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        padding: '20px 0'
      }}>
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card className="shadow-lg border-0" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                <Card.Header style={{ 
                  background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                  color: 'white',
                  textAlign: 'center',
                  padding: '25px',
                  border: 'none'
                }}>
                  <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>
                    <i className="fas fa-check-circle" style={{ fontSize: '48px', marginBottom: '15px', display: 'block' }}></i>
                    Pagamento Confirmado!
                  </div>
                  <div style={{ fontSize: '16px', opacity: '0.9' }}>
                    Bem-vindo ao seu novo plano!
                  </div>
                </Card.Header>
                
                <Card.Body style={{ 
                  textAlign: 'center', 
                  padding: '40px 30px',
                  background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
                }}>
                  <div style={{ 
                    fontSize: '20px', 
                    marginBottom: '25px',
                    color: '#2d3748',
                    fontWeight: '600'
                  }}>
                    🎉 <strong>Parabéns! Seu pagamento foi aprovado com sucesso!</strong>
                  </div>
                  
                  <div style={{ 
                    fontSize: '16px', 
                    marginBottom: '25px',
                    color: '#4a5568',
                    lineHeight: '1.6'
                  }}>
                    Para acessar todo o conteúdo do seu plano e começar sua jornada rumo à nota 1000:
                  </div>
                  
                  <div style={{ 
                    background: 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)',
                    padding: '20px',
                    borderRadius: '15px',
                    marginBottom: '25px',
                    border: '2px solid #e1bee7'
                  }}>
                    <div style={{ 
                      fontSize: '18px', 
                      color: '#6a1b9a', 
                      fontWeight: 'bold',
                      marginBottom: '10px'
                    }}>
                      <i className="fas fa-info-circle" style={{ marginRight: '8px' }}></i>
                      Próximo Passo Importante
                    </div>
                    <div style={{ 
                      fontSize: '16px', 
                      color: '#4a148c',
                      fontWeight: '500'
                    }}>
                      <i>Clique em "Entendi",</i><br />
                      <i>(Você será redirecionado para a página de login, basta logar novamente)</i>
                    </div>
                  </div>

                  <div style={{ 
                    fontSize: '14px', 
                    color: '#718096',
                    fontStyle: 'italic',
                    marginBottom: '20px'
                  }}>
                    <i className="fas fa-lock" style={{ marginRight: '5px' }}></i>
                    Processo seguro e automático
                  </div>
                </Card.Body>
                
                <Card.Footer style={{ 
                  background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                  display: 'flex', 
                  justifyContent: 'center',
                  padding: '25px',
                  border: 'none'
                }}>
                  <Button
                    onClick={handleLogout}
                    style={{ 
                      minWidth: '200px',
                      padding: '12px 30px',
                      fontSize: '18px',
                      fontWeight: 'bold',
                      background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                      border: 'none',
                      borderRadius: '50px',
                      boxShadow: '0 8px 25px rgba(40, 167, 69, 0.3)',
                      transition: 'all 0.3s ease',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 12px 35px rgba(40, 167, 69, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 8px 25px rgba(40, 167, 69, 0.3)';
                    }}
                  >
                    <i className="fas fa-arrow-right" style={{ marginRight: '10px' }}></i>
                    Entendi!
                  </Button>
                </Card.Footer>
              </Card>
              
              {/* Mensagem adicional */}
              <div style={{ 
                textAlign: 'center', 
                marginTop: '20px',
                color: 'white',
                fontSize: '14px',
                opacity: '0.9'
              }}>
                <i className="fas fa-shield-alt" style={{ marginRight: '5px', color: 'black' }}></i>   
                <i style={{ marginRight: '5px', color: 'black' }}>
                  Seus dados estão seguros e protegidos
                </i>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Template>
  );
}

export default Obrigado;